import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Hero from './components/Hero';
import CategoryDropdown from './components/CategoryDropdown';
import CategoryGrid from './components/CategoryGrid';
import SeoContent from './components/SeoContent';
import FaqSection from './components/FaqSection';
import ArticleCards from './components/ArticleCards';

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <CategoryDropdown />
        <CategoryGrid />
        <SeoContent />
        <ArticleCards />
        <FaqSection />
      </main>
      <Footer />
    </>
  );
}